import { LoginResponse } from "@/views/authentication/types/auth.type";
import { User } from "@/views/modules/user-management/users/types/userType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  id: string | number | null;
  token: string | null;
  isLoggedIn: boolean;
  user: User | null;
  permissions: string[];
  firstRoute: string | null;
}

const initialState: AuthState = {
  id: null,
  token: null,
  isLoggedIn: false,
  user: null,
  permissions: [],
  firstRoute: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<LoginResponse>) => {
      console.log(action.payload);
      state.id = action.payload.id;
      // state.token = action.payload.token;
      state.permissions = action.payload.permissions;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.id = null;
      // state.token = null;
      state.permissions = [];
      state.isLoggedIn = false;
      state.user = null;
      state.firstRoute = null;
    },
    setMyProfile: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setFirstRoute: (state, action: PayloadAction<string>) => {
      state.firstRoute = action.payload;
    },
  },
});

export const { login, logout, setMyProfile, setFirstRoute } = authSlice.actions;
export default authSlice.reducer;